import React from 'react';

import { flagStyles } from '../settings';

const SvgGF = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1872px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGF;
